module.exports = __webpack_public_path__ + "static/media/logo-text-white-108x60.69356ae0.svg";